import 'core-js/features/string/match-all';

export const toTicketString = ct => `{${ct.displayStatus}:${ct.hash}:${ct.stake}:${ct.win}:${ct.winningMethod}}`;

const toTicket = ([, displayStatus, hash, stake, win, winningMethod]) => ({
    displayStatus,
    hash,
    stake,
    win,
    winningMethod
});

const textRegexp = /{(\w+):([a-zA-Z_0-9-.:]+):(-?[\d.,]+):([\d.,]+):([a-zA-Z_0-9- .:]+)}/g;
const ticketEditRegexp = /{((?!Analysis\b)\b\w+):([a-zA-Z_0-9-.:]+):(-?[\d.,]+):([\d.,]+):([a-zA-Z_0-9- .:]+)}/g;

const byHash = (acc, item) => ({ ...acc, [item.hash]: item });

export const ticketsFromMessage = (message, edit) =>
    (Array.from(message.matchAll(edit ? ticketEditRegexp : textRegexp)) || []).map(toTicket).reduce(byHash, {});

export const stripTickets = str => str.replace(textRegexp, '').trim();
